import { render, staticRenderFns } from "./AddAct.vue?vue&type=template&id=71b8ad54"
import script from "./AddAct.vue?vue&type=script&lang=js"
export * from "./AddAct.vue?vue&type=script&lang=js"
import style0 from "./AddAct.vue?vue&type=style&index=0&id=71b8ad54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports